import { render, staticRenderFns } from "./PaymentIcons.vue?vue&type=template&id=3d819ee4&scoped=true&"
import script from "./PaymentIcons.vue?vue&type=script&lang=js&"
export * from "./PaymentIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d819ee4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d819ee4')) {
      api.createRecord('3d819ee4', component.options)
    } else {
      api.reload('3d819ee4', component.options)
    }
    module.hot.accept("./PaymentIcons.vue?vue&type=template&id=3d819ee4&scoped=true&", function () {
      api.rerender('3d819ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaymentIcons.vue"
export default component.exports